import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-30px" });

  return (
    <footer 
      ref={ref}
      className="py-12 md:py-16 px-6 bg-gradient-to-b from-[#5D4037] to-[#4A3228] text-[#F9F7F2]"
      data-testid="footer"
    >
      <motion.div
        className="max-w-2xl mx-auto text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.6 }}
      >
        {/* Names */}
        <h2 className="font-heading text-2xl md:text-3xl mb-3">
          Carolina <span className="font-['Times_New_Roman'] mx-2 text-[#CCA598]">&</span> Luciano
        </h2>
        
        {/* Date */}
        <p className="font-body text-xs tracking-[0.2em] uppercase text-[#D7CCC8] mb-6">
          2 de Octubre de 2026
        </p>

        {/* Heart Icon */}
        <motion.div 
          className="flex justify-center mb-6"
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <Heart className="w-5 h-5 text-[#CCA598]" fill="currentColor" />
        </motion.div>

        {/* Message */}
        <p className="font-accent text-lg md:text-xl text-[#D7CCC8]">
          Os esperamos con mucha ilusión
        </p>

        {/* Copyright */}
        <p className="font-body text-xs text-[#8D6E63] mt-10">
          Con amor, Carolina & Luciano
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;
